import { ReloadButton } from '@aibees/shared/components';
import { useBrowsePaymentCardApi } from '@aibees/shared/features/billing-profile/api/use-browse-payment-card-api';
import { useReadCustomerApi } from '@aibees/shared/features/billing-profile/api/use-read-customer-api';
import { classnames } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { DefaultCardButton } from '../default-card-button';
import { NoPaymentCard } from '../no-payment-card';
import { PaymentCardInfo } from '../payment-card-info';
import { PaymentMethodHeader } from '../payment-method-header';
import { RemovePaymentCard } from '../remove-payment-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentMethodsProps as Props } from './types';

export const PaymentMethods = memo(({ className }: Props) => {
  const workspaceId = useWorkspace()?.id ?? '';
  const { data, isError, isLoading, refetch } = useBrowsePaymentCardApi();
  const { data: customerData } = useReadCustomerApi(workspaceId);

  return (
    <Styled.Wrapper
      className={classnames('PaymentMethods', className)}
      sx={SX.root}
    >
      <PaymentMethodHeader />

      {data && data?.content?.length ? (
        data?.content?.map((x) => {
          const isDefault = customerData?.method === x.id;

          return (
            <Styled.Content key={x.id} sx={SX.box(isDefault)}>
              <PaymentCardInfo
                item={x.card}
                isPaymentMethod
                paymentMethodId={x}
              />
              <Stack direction="row" gap={1}>
                <DefaultCardButton item={x} />
                <RemovePaymentCard item={x} />
              </Stack>
            </Styled.Content>
          );
        })
      ) : (
        <NoPaymentCard />
      )}
      {isError && <ReloadButton onReload={refetch} />}
    </Styled.Wrapper>
  );
});

PaymentMethods.displayName = 'PaymentMethods';
